module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAA50lEQVRYR+1VwQ3CMAy8TEBH6AYwAkwAGwAbeASYIMcEtBNQNoAJYCRkKUVRSoh4gIpkP+vT9Xw+Kw4jKTcSHTAh6SbMEXOkdJ2WEcvIf2ZERFYAlgBq51znvT+8myTg1wAq51zjvW8L+E3gV1hLsuvxz6sRkRmAW0K0J7l7RR5EnJLelmSTwauIY9JbkLzot1iIEuh0cV1JzjPEOo26F9eZpLo6KBG5A5jmBh2lEF2N2jSJVP9+NfrzsHe1tgbQ5PbdCw143X31IV4plH8Y1tKdf7tvb429NaWMWUYsI5aRkgOWkZJDD8tKWiGFYxieAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/portmenu.png
// module id = T325
// module chunks = 1